import { useState } from "react";
import { MotionFlex as Flex } from "utils/motion";
import ArrowLeft from "components/icons/ArrowLeft";
import Button from "components/base/Button";

const variants = { regular: { x: 0 }, selected: { x: -5 } };

export default function ArrowButton({ text, ...props }) {
  const [isHovered, setHovered] = useState(false);

  return (
    <Button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...props}
      variant="floating"
      colorScheme="white"
      px={0}
    >
      {text}
      <Flex
        variants={variants}
        initial="regular"
        ml={text ? "sm" : 0}
        animate={isHovered ? "selected" : "regular"}
      >
        <ArrowLeft />
      </Flex>
    </Button>
  );
}
